<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px;"
>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
            v-if="search_menu_items.length > 0"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>

            <v-list>
                <v-list-item
                    v-for="(item, key) in search_menu_items"
                    :key=key
                    v-on:click="item.on_click"
                >
                    <v-list-item-title>{{item.text}}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-text-field>

    <div
        v-if="count_customer != null"
        style="margin-bottom: 5px"
    >
        {{count_customer.toLocaleString()}} contacts have been synced.  Table does not show all contacts &mdash; you can use full text search to find a specific contact.
    </div>

    <v-select
        label="Contact Type"
        v-model="customer_type"
        v-if="supports_customer_type"
        :items="customer_type_choices"
        v-on:change="doUpdate"
    />

    <v-row>
        <v-col class="flex-grow-0">

        <v-checkbox
            label="Active"
            v-model="include_active"
            v-if="supports_customer_type"
            v-on:change="doUpdate"
            style="margin-top: -15px"
        />
        </v-col>

        <v-col class="flex-grow-0">
        <v-checkbox
            label="Inactive"
            v-model="include_inactive"
            v-if="supports_customer_type"
            v-on:change="doUpdate"
            style="margin-top: -15px"
        />
        </v-col>
    </v-row>

    <v-data-table
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"

        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
            }"
    >

        <template v-slot:item.customer_phone_numbers="{ item }">
            <div
                v-for="(number, index) in item.customer_phone_numbers"
                :key="index"
            >
                <a
                    v-on:click="onClickPhoneNumber(item, number)"
                    class="number_hyperlink"
                >
                    {{$rc.pretty(number,'endpoint')}}
                </a>
            </div>
        </template>

         <template v-slot:item.customer_emails="{ item }">
             <div
                v-for="(email, index) in item.customer_emails"
                :key="index"
            >
                {{email}}
            </div>
        </template>

        <template v-slot:item.customer_type="{ item }">
             {{prettyCustomerType(item)}}
        </template>

        <template v-slot:item.action="{ item }">

            <v-menu
                bottom
                offset-y
            >

            <template v-slot:activator="{ on }">

                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>

            </template>

            <v-list>

                <v-list-item
                    v-on:click="onClickViewInCRM(item)"
                    v-show="item.url_view_customer_in_crm != null"
                >
                    <v-list-item-title>View in {{integration_name}}...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                 <v-list-item
                    v-on:click="onClickManualOptInOut(item)"
                >
                    <v-list-item-title>Opt in/out...</v-list-item-title>
                </v-list-item>

                <v-divider v-if="show_red_chirp_conversation_tab_light(item) || show_red_chirp_conversation_tab_dark(item)"/>

                <m-restricted-menu-list-item
                    v-on:click="onClickViewRedChirpTab(item, true)"
                    v-if="show_red_chirp_conversation_tab_dark(item)"
                    text="View RedChirp Tab (dark theme)..."
                />

                <m-restricted-menu-list-item
                    v-on:click="onClickViewRedChirpTab(item, false)"
                    v-if="show_red_chirp_conversation_tab_light(item)"
                    text="View RedChirp Tab (light theme)..."
                />

                <v-list-item
                    v-on:click="onClickTechnicalData(item)"
                >
                    <v-list-item-title>Technical Details...</v-list-item-title>
                </v-list-item>

            </v-list>

            </v-menu>



        </template>

     </v-data-table>

     <m-select-employee-endpoint-dialog
        :title="select_endpoint_title"
        ref="select-endpoint-dialog"
        v-on:select-endpoint="after_select_employee_endpoint"
    />

    <m-create-bulk-opt-out-dialog
        ref="bulk-opt-out-dialog"
    />

</v-container>
</m-pageframe>
</template>

<script>
const E164 = require('@/js/E164.js');
const { v4: uuidv4 } = require('uuid');
const _ = require('lodash');

export default {
data() {
    return {
        full_text: null,

        results: [],

        customer_type: null,

        after_select_employee_endpoint: () => {},
        select_endpoint_title: null,

        include_active: true,
        include_inactive: false,

        count_customer: null,
    }
},

mounted () {
    this.doUpdate();
    this.doUpdateCount();
},

methods: {

    update: _.debounce(function(){
        this.doUpdate();
    }, 751),

    doUpdate()
    {
        let my_search = uuidv4();

        let search = {
            'full_text' : this.full_text,
            'organization_id' : this.$route.params.organization_id,
            'content_type' : this.$route.params.content_type,
            'customer_type': this.customer_type,
        };

        if ( this.supports_customer_type )
        {
            if ( this.include_active && this.include_inactive )
            {
                // do nothing
            }
            else if ( this.include_active )
            {
                search['is_active'] = true;
            }
            else if ( this.include_inactive )
            {
                search['is_active'] = false;
            }
            else
            {
                this.results = [];
                return;
            }
        }


        this.$rc.rest(
            'LIST: /api/v1/integrations/crm/customers',

            search,

            (data) => {
                this.results = data.results;
            },

            () => {
                this.$rc.hideSpinner();
                this.$rc.alert('Error','Unable to list customers');
            },
        );
    },

    doUpdateCount()
    {
        this.$rc.rest({
            'spinner': false,
            'endpoint': 'GET: /api/v1/integrations/crm/customers/count/:organization_id/:content_type',
        
            'params' : {
                    'organization_id': this.$route.params.organization_id,
                    'content_type': this.$route.params.content_type,
                },
        
            'on_success': (data) => {
                    this.count_customer = data.count;
                },
        
            'on_error': () => {},
        });
    },

    onClickPhoneNumber(item, number)
    {
        this.after_select_employee_endpoint = (employee_endpoint) => {
             let params = {
                'customer_id' : item.customer_id,
                'organization_id' : item.organization_id,
                'content_type' : this.$route.params.content_type,
                'customer_endpoint' : number,
                'employee_endpoint' : employee_endpoint
            };

            this.$rc.showSpinner();

            this.$rc.rest(
                'PUT: /api/v1/integrations/crm/customers/start-conversation',

                params,

                (data) => {
                    this.$rc.hideSpinner();

                    this.$router.push({
                        'name': 'home-routed',
                        'params' : data,
                        }).catch(e=>{}); // swallow any exception
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to start conversation');
                },
            );
        };

        if ( item.first_name == null || item.first_name.trim() == '' )
        {
            this.select_endpoint_title = 'Select number to text '+this.$rc.pretty(item.number,'endpoint')+' from';
        }
        else
        {
            this.select_endpoint_title = 'Select number to text '+item.first_name+' from';
        }

        this.$refs['select-endpoint-dialog'].showDialog();
    },

    onClickTechnicalData(item)
    {
         this.$rc.copy_code_dialog({
                'title': 'Technical Details',
                'object': item,
            });
    },

    onClickViewInCRM(item)
    {
        window.open(item.url_view_customer_in_crm,"_blank");
    },

    onClickManualOptInOut(item)
    {
        this.$refs['bulk-opt-out-dialog'].showDialog(
            this.$route.params.organization_id,
            this.$rc.pretty(item.customer_phone_numbers, 'comma_list'),
            item.full_name
        );
    },

    show_red_chirp_conversation_tab_dark(item) {
        return item.extra_fields.red_chirp_conversation_tab_dark != null && this.$rc.$state.isAuthActorSystemAdmin();
    },

    show_red_chirp_conversation_tab_light(item) {
        return item.extra_fields.red_chirp_conversation_tab_light != null && this.$rc.$state.isAuthActorSystemAdmin();
    },

    onClickViewRedChirpTab(item, dark_theme)
    {
        if ( dark_theme )
        {
            window.open(item.extra_fields.red_chirp_conversation_tab_dark,"_blank");
        }
        else
        {
            window.open(item.extra_fields.red_chirp_conversation_tab_light,"_blank");
        }
    },

    prettyCustomerType(item)
    {
        if ( this.is_clear_care && item.customer_type == 'customer' )
        {
            return 'client';
        }

        return item.customer_type;
    },
},

computed: {
    integration_name() {
        return this.$rc.pretty(this.$route.params.content_type, 'integration_name');
    },

    title() {
        let integration_name = this.integration_name;

        return `Search ${integration_name} Contacts`;
    },

    is_clear_care() {
        return this.$route.params.content_type == 'clear-care';
    },

    supports_customer_type() {
        return this.is_clear_care;
    },

    headers() {
        if ( this.supports_customer_type )
        {
            return [
                { 'text' : 'Brand', 'value' : 'brand_label' },
                { 'text' : 'Type', 'value' : 'customer_type' },
                { 'text' : 'First Name', 'value' : 'first_name' },
                { 'text' : 'Last Name', 'value' : 'last_name' },
                { 'text' : 'City', 'value' : 'city' },
                { 'text' : 'State', 'value' : 'state' },
                { 'text' : 'Zip / Postal', 'value' : 'zip' },
                { 'text' : 'Email', 'value' : 'customer_emails' },
                { 'text' : 'Phone', 'value' : 'customer_phone_numbers' },
                { 'text' : 'Action', 'value' : 'action' }
            ];
        }
        else
        {
            return [
                { 'text' : 'Brand', 'value' : 'brand_label' },
                { 'text' : 'First Name', 'value' : 'first_name' },
                { 'text' : 'Last Name', 'value' : 'last_name' },
                { 'text' : 'City', 'value' : 'city' },
                { 'text' : 'State', 'value' : 'state' },
                { 'text' : 'Zip / Postal', 'value' : 'zip' },
                { 'text' : 'Email', 'value' : 'customer_emails' },
                { 'text' : 'Phone', 'value' : 'customer_phone_numbers' },
                { 'text' : 'Action', 'value' : 'action' }
            ];
        }
    },

    customer_type_choices()
    {
        if ( this.is_clear_care )
        {
            return [
                {'text': 'Client', 'value' : 'customer'},
                {'text': 'Caregiver', 'value' : 'caregiver'},
                {'text': 'Client Contact', 'value' : 'client-contact'},
                //{'text': 'Applicant', 'value' : 'applicant'}, // not showing because not everyone has one...
            ];
        }

        return [];
    },

    search_menu_items()
    {
        let ret = [];
        let content_type = this.$route.params.content_type;

        return ret;
    },
},
}
</script>

<style lang="scss" scoped>

.number_hyperlink:hover
{
    text-decoration: underline;
}
</style>